import React, { Component } from 'react';
import PropTypes from 'prop-types';
import RadioGroup from './RadioGroup';
import CategoryTable from './../LightTable/specific/CategoryTable';
import SpecificEntitiesTable from './../LightTable/specific/SpecificEntitiesTable';
import { SECTION_ENTITIES, SECTION_ALL_ENTITIES, SECTION_CATEGORIES } from "../../constants";
import { FormattedMessage } from 'react-intl';

class CategoriesEntitiesSelector extends Component {
    static propTypes = {
        section: PropTypes.string,
        values: PropTypes.array,
        onChange: PropTypes.func.isRequired,
        allEntitiesMsgId: PropTypes.string
    }

    static defaultProps = {
        section: "all-third-parties-section",
        values: [],
        allEntitiesMsgId: "Alerts_Create_UIText_name.step1.entities.all"
    }

    constructor(props) {
        super(props);

        this.state = {
            selectedSection: props.section,
            selectedValues: props.values
        }

        this.handleChangeOption = this.handleChangeOption.bind(this);
        this.handleChangeEntities = this.handleChangeEntities.bind(this);
        this.handleChangeCategories = this.handleChangeCategories.bind(this);
    }

    componentWillUpdate(nextProps) {
        if (nextProps.section !== this.props.section) {
            this.setState({ selectedSection: nextProps.section, selectedValues: nextProps.values })
        }
    }

    triggerChange() {
        let changeObject = {
            selectedCategories: [],
            selectedThirdPartiesIds: [],
            thirdPartySelection: this.state.selectedSection
        }
        switch (this.state.selectedSection) {
            case SECTION_CATEGORIES:
                changeObject.selectedCategories = this.state.selectedValues;
                break;
            case SECTION_ENTITIES:
                changeObject.selectedThirdPartiesIds = this.state.selectedValues;
        }
        this.props.onChange(changeObject);
    }

    handleChangeEntities(values) {
        this.setState({
            selectedSection: SECTION_ENTITIES,
            selectedValues: values
        }, this.triggerChange);
    }

    handleChangeCategories(values) {
        this.setState({
            selectedSection: SECTION_CATEGORIES,
            selectedValues: values
        }, this.triggerChange);
    }

    handleChangeOption(e) {
        this.setState({
            selectedSection: e.target.value,
            selectedValues: []
        }, this.triggerChange)
    }

    getSelectedOption() {
        switch (this.state.selectedSection) {
            case SECTION_ALL_ENTITIES:
                return <div className="all-third-parties-section">
                    <FormattedMessage id={this.props.allEntitiesMsgId} />
                </div>
            case SECTION_CATEGORIES:
                return <CategoryTable selectedCategoriesIds={this.state.selectedValues} onChange={this.handleChangeCategories}/>
            case SECTION_ENTITIES:
                return <SpecificEntitiesTable entityIds={this.state.selectedValues} onChange={this.handleChangeEntities}/>
        }
    }

    render() {
        const options = [
            {
                label: <FormattedMessage id={"RSS_Add_UIText_addRssFeed.thirdParties.selectAll"}/>,
                value: SECTION_ALL_ENTITIES
            },
            {
                label: <FormattedMessage id={"RSS_Add_UIText_addRssFeed.thirdParties.selectByCategory"}/>,
                value: SECTION_CATEGORIES
            },
            {
                label: <FormattedMessage id={"RSS_Add_UIText_addRssFeed.thirdParties.selectBySpecific"}/>,
                value: SECTION_ENTITIES
            }
        ]
        return <div className={"categories-entities-selector"}>
            <RadioGroup options={options} onChange={this.handleChangeOption} value={this.state.selectedSection}/>
            {this.props.children}
            <div className={'selected-option'}>
                {this.getSelectedOption()}
            </div>
        </div>
    }
}

export default CategoriesEntitiesSelector;


// WEBPACK FOOTER //
// ./src/scripts/reusable/Form/CategoriesEntitiesSelector.jsx